__turbopack_context__.v({
  "toggleButton": "ThemeToggle-module__94YIEq__toggleButton",
});
